import angular from 'angular';
import crmNotify from './crmNotify';
import './style.scss';

export default angular
  .module('components.crmNotify', [])
  .component('crmNotify', crmNotify).name;
